import React, { useState } from 'react';
import { Dialog } from 'primereact/dialog';
import { UserSummaryType } from '../../../../../api/types/user/user-summary.type';
import { CourseMetadataType } from '../../../../../api/types/programs/course/course-metadata.type';
import { ProgramDetails } from '../../../../../api/types/programs/program-details';
import { AddStudentsDialogContent } from './components/add-students-dialog-content';
import { AddNewStudentFromPreviusYearsTab } from './components/add-new-student-from-previus-years-tab';
import TabBar from '../../../../../component/tab-bar/tab-bar';

interface AddStudentsDialogProps {
  visible: boolean;
  selectedYear: number | null;
  selectedUsers: UserSummaryType[];
  addCourses: boolean;
  selectedCourses: CourseMetadataType[];
  loading: boolean;
  combinedCourses: CourseMetadataType[];
  program: ProgramDetails;
  onHide: () => void;
  onSelectedUsersChange: (users: UserSummaryType[]) => void;
  onAddCoursesChange: (addCourses: boolean) => void;
  onSelectedCoursesChange: (courses: CourseMetadataType[]) => void;
  onApprove: (
    selectedUsers: UserSummaryType[],
    setLoading: (loading: boolean) => void,
  ) => Promise<void>;
}

const tabs = ['משתמשים מהשלוחה', 'משתמשים משנים קודמות'];

export const AddStudentsDialog: React.FC<AddStudentsDialogProps> = ({
  visible,
  selectedYear,
  selectedUsers,
  addCourses,
  selectedCourses,
  loading,
  combinedCourses,
  program,
  onHide,
  onSelectedUsersChange,
  onAddCoursesChange,
  onSelectedCoursesChange,
  onApprove,
}) => {
  const [selectedIndex, setSelectedIndex] = useState(0);

  // Reset selectedIndex when dialog becomes visible
  React.useEffect(() => {
    if (visible) {
      setSelectedIndex(0);
    }
  }, [visible]);

  const pages = [
    <AddStudentsDialogContent
      selectedUsers={selectedUsers}
      addCourses={addCourses}
      selectedCourses={selectedCourses}
      loading={loading}
      combinedCourses={combinedCourses}
      selectedYear={selectedYear}
      program={program}
      visible={visible}
      onSelectedUsersChange={onSelectedUsersChange}
      onAddCoursesChange={onAddCoursesChange}
      onSelectedCoursesChange={onSelectedCoursesChange}
      onApprove={onApprove}
      onHide={onHide}
    />,
    <AddNewStudentFromPreviusYearsTab
      selectedYear={selectedYear}
      program={program}
      selectedUsers={selectedUsers}
      addCourses={addCourses}
      selectedCourses={selectedCourses}
      visible={visible}
      onSelectedUsersChange={onSelectedUsersChange}
      onAddCoursesChange={onAddCoursesChange}
      onSelectedCoursesChange={onSelectedCoursesChange}
      onApprove={onApprove}
      loading={loading}
    />,
  ];

  return (
    <Dialog
      header={`הוספת סטודנטים ${selectedYear !== null ? `לשנה ${selectedYear === 0 ? 'א׳' : selectedYear === 1 ? 'ב׳' : 'ג׳'}` : ''}`}
      visible={visible}
      style={{
        height: '100vh',
        width: '800px',
        backgroundColor: 'white',
        padding: '8px',
        borderRadius: '8px',
      }}
      onHide={onHide}
    >
      <TabBar
        tabs={tabs}
        onClick={(index) => {
          setSelectedIndex(index);
        }}
      />
      <div style={{ marginTop: '20px' }}>{pages[selectedIndex]}</div>
    </Dialog>
  );
};
